import { RecordModel } from 'src/app/layout/record-model';
import { ModuleStructure } from 'src/app/models/module-structure';
import { tap, switchMap } from 'rxjs/operators';
import { BaseTimeComponent } from './../../shared/base-component/base-component.component';
import { Component, OnInit, Injector, ViewChild, TemplateRef } from '@angular/core';
import { FilterField } from '../../models/FilterField';
import { FieldDataType } from '@app/models/module-structure';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-time-logs',
  templateUrl: './time-logs.component.html',
  styleUrls: ['./time-logs.component.less']
})
export class TimeLogsComponent extends BaseTimeComponent implements OnInit {
  selectedRecords = [];
  isLoading = true;
  tempNote = '';
  absEntry = 0;
  lineId;
  @ViewChild('drawerTemplate', { static: false }) drawerTemplate?: TemplateRef<{
    $implicit: {};
    drawerRef: NzDrawerRef<string>;
  }>;
  @ViewChild('footerTemp', { static: false }) footerTemp?: TemplateRef<{
    $implicit: {};
    drawerRef: NzDrawerRef<string>;
  }>;
  moduleStructure: ModuleStructure;
  drawerRef: NzDrawerRef;
  filterFields: FilterField[] = [];
  approvalType = '';
  isApproved = true;
  constructor(injector: Injector, private drawerService: NzDrawerService) {
    super(injector);
  }

  ngOnInit() {
    const approve$ = this.layoutService.timesheetApprove$
      .pipe(
        tap((type) => {
          if (type.startsWith('PM_APPROVE_')) {
            const recordId = type.slice(11, type.length);
            this.PMApprove(recordId);
          }
          else if (type.startsWith('CUSTOMER_APPROVE_')) {
            const recordId = type.slice(17, type.length);
            this.CustomerApprove(recordId);
          }
        })
      )
      .subscribe();
    this.subs.push(approve$);
  }
  PMApprove(recordId) {
    this.absEntry = recordId;
    setTimeout(() => {
      this.drawerRef = this.drawerService.create({
        nzTitle: this.layoutService.translate('Approval Notes'),
        nzFooter: this.footerTemp,
        nzContent: this.drawerTemplate,
        nzPlacement: 'bottom'
      })
      const afterClose$ = this.drawerRef.afterClose.subscribe(() => {
        this.layoutService.refreshListEmitter.emit();
      });
      this.subs.push(afterClose$);
    }, 300);
  }
  CustomerApprove(recordId) {
    this.absEntry = recordId;
    setTimeout(() => {
      this.drawerRef = this.drawerService.create({
        nzTitle: this.layoutService.translate('Approval Notes'),
        nzFooter: this.footerTemp,
        nzContent: this.drawerTemplate,
        nzPlacement: 'bottom'
      })
      const afterClose$ = this.drawerRef.afterClose.subscribe(() => {
        this.layoutService.refreshListEmitter.emit();
      });
      this.subs.push(afterClose$);
    }, 300);
  }
  submit() {
    const isCustomer = this.approvalType == 'CUSTOMER_APPROVE';
    const edit$ = this.layoutService.getValuesOnEdit(this.moduleStructure, 10009, this.absEntry) as Observable<any>;
    const editRes = edit$
      .pipe(
        tap((res: any) => {
          const model = JSON.parse(res.Values) as RecordModel;
          const category = model.Categories?.find(x => x.Id === 'PM_TimeSheetLineDataCollection|PM_TimeSheetLineData');
          if (category == null) return;
          this.lineId = category.Lines[0].Properties.find(x => x.Name === 'LineId')?.ValueAsObject;
        }),
        switchMap(() => this.timeService.approveTimeRecord(isCustomer, this.absEntry, this.lineId, this.tempNote, this.isApproved)),
        tap((res: any) => {
          if (res.Error != null && res.Error == true) {
            this.notificationService.error(this.layoutService.translate('Error'), res.Data)
          }
          else {
            this.notificationService.success(this.layoutService.translate('Success'), res.Data)
            this.drawerRef.close();
            this.tempNote = '';
          }
        })
      )
      .subscribe();
    this.subs.push(editRes);
  }
}
